import React from 'react'
import Routers from '../src/routers/Routers'

const App = () => {
  return (
    <div>
<Routers/>
    </div>
  )
}

export default App
